import { selectAssetTypeById } from "@overmap-ai/core"
import { createFileRoute, notFound } from "@tanstack/react-router"
import { appStore } from "src/store"
import { AssetTypeDetailView } from "src/views/AssetTypeDetailView/AssetTypeDetailView"
import { assetTypeDetailViewStaticData } from "src/views/AssetTypeDetailView/constants"
import { NotFound } from "src/views/AssetTypeDetailView/NotFound"

export const Route = createFileRoute(
	"/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/asset-types/$assetTypeId/",
)({
	component: AssetTypeDetailView,
	notFoundComponent: NotFound,
	staticData: assetTypeDetailViewStaticData,
	loader: ({ params }) => {
		const assetType = selectAssetTypeById(params.assetTypeId)(appStore.getState())
		if (!assetType) throw notFound()
	},
})
